import {isDaumBlogDomain} from "../utils/UriUtil";

const cdnNumber = Math.ceil(Math.random() * 4);
const skinBaseUrl = isDaumBlogDomain()
  ? window.Config.production ? 'https://t1.daumcdn.net/daumblog' : 'https://beta.daumcdn.net/daumblog_test'
  : window.Config.production ? `https://tistory${cdnNumber}.daumcdn.net/tistory` : 'https://beta.daumcdn.net/tistory_test';


class CDN {
  static getSkinUrl(path) {
    return `${skinBaseUrl}${path}`
  }
}

export default CDN
